import React from 'react';
import { Modal, Button } from 'antd';
import { scrollTriggerIntoView } from '../util/modalUtils';
import { useNavigate } from 'react-router-dom';
import { useModalWidth } from '../hooks/useModalWidth';

/**
 * FeedbackModal
 * Props:
 *  - visible: boolean
 *  - onClose: () => void
 *
 * Behavior:
 *  - Primary button: navigates to /dashboard/feedback and closes the modal
 *  - Secondary button: closes the modal
 */
export default function FeedbackModal({ visible, onClose }) {
  const navigate = useNavigate();
  const modalWidth = useModalWidth();

  React.useEffect(() => {
    if (visible) scrollTriggerIntoView();
  }, [visible]);

  const handleYes = () => {
    // navigate to the embedded feedback page and close modal
    navigate('/dashboard/feedback');
    if (onClose) onClose();
  };

  const handleMaybeLater = () => {
    if (onClose) onClose();
  };

  return (
    <Modal
      open={!!visible}
      onCancel={handleMaybeLater}
      footer={null}
      centered
      closable={false}
      width={modalWidth}
      zIndex={4000}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 18, alignItems: 'stretch' }}>
        <h2 className="modal-header-title" style={{ margin: 0, fontWeight: 800, color: '#184b18' }}>
          Would you like to leave a feedback?
        </h2>

        <p style={{ margin: 0, color: '#444', lineHeight: 1.4 }}>
          Your feedback helps us improve our services and provide you with a better experience.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 8 }}>
          <Button
            type="primary"
            size="large"
            onClick={handleYes}
            style={{
              background: '#00b050',
              borderColor: '#00b050',
              height: 48,
              borderRadius: 8,
              fontWeight: 700,
            }}
            aria-label="Yes, share feedback"
          >
            Yes, Share Feedback
          </Button>

          <Button
            type="default"
            size="large"
            onClick={handleMaybeLater}
            style={{
              background: '#fff',
              borderRadius: 8,
              height: 48,
              fontWeight: 600,
            }}
            aria-label="Maybe later"
          >
            Maybe Later
          </Button>
        </div>
      </div>
    </Modal>
  );
}
